import { jsx as _jsx } from "react/jsx-runtime";
import { mutations, queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import List from "components/Lists/List";
const { forum: { GET_SECTIONS } } = queries;
const { forum: { DELETE_SECTION } } = mutations;
const SectionsList = () => (_jsx(List, { deleteMutation: DELETE_SECTION, itemNamePlural: "sections", label: "Sections", listQuery: GET_SECTIONS, listQueryDataName: "sections", pathPrefix: "/forum" }));
export default SectionsList;
